"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.deleteAttributes = deleteAttributes;
exports.empty = empty;
exports.forOwn = forOwn;
exports.get = get;
exports.getObjectField = getObjectField;
exports.hasOwnProperty = hasOwnProperty;
exports.iterate = iterate;
exports.mapKeyValue = mapKeyValue;
exports.mapValue = mapValue;
exports.omit = omit;
exports.toPairs = toPairs;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _is = require("./is");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(iterate);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function hasOwnProperty(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

function iterate(object) {
  var symbol,
      key,
      _iterator,
      _step,
      _key,
      _args = arguments;

  return _regenerator.default.wrap(function iterate$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          symbol = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
          _context.t0 = _regenerator.default.keys(object);

        case 2:
          if ((_context.t1 = _context.t0()).done) {
            _context.next = 9;
            break;
          }

          key = _context.t1.value;

          if (!hasOwnProperty(object, key)) {
            _context.next = 7;
            break;
          }

          _context.next = 7;
          return [object[key], key];

        case 7:
          _context.next = 2;
          break;

        case 9:
          if (!symbol) {
            _context.next = 27;
            break;
          }

          _iterator = _createForOfIteratorHelper(Object.getOwnPropertySymbols(object));
          _context.prev = 11;

          _iterator.s();

        case 13:
          if ((_step = _iterator.n()).done) {
            _context.next = 19;
            break;
          }

          _key = _step.value;
          _context.next = 17;
          return [object[_key], _key];

        case 17:
          _context.next = 13;
          break;

        case 19:
          _context.next = 24;
          break;

        case 21:
          _context.prev = 21;
          _context.t2 = _context["catch"](11);

          _iterator.e(_context.t2);

        case 24:
          _context.prev = 24;

          _iterator.f();

          return _context.finish(24);

        case 27:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[11, 21, 24, 27]]);
}

function forOwn(object, callback) {
  var symbol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var _iterator2 = _createForOfIteratorHelper(iterate(object, symbol)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = (0, _slicedToArray2.default)(_step2.value, 2),
          value = _step2$value[0],
          key = _step2$value[1];

      callback(value, key);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

function mapValue(object, callback) {
  var result = {};
  forOwn(object, function (v, k) {
    result[k] = callback(v, k);
  });
  return result;
}

function mapKeyValue(object, callback) {
  var result = {};
  forOwn(object, function (v, k) {
    var _callback = callback(v, k),
        _callback2 = (0, _slicedToArray2.default)(_callback, 2),
        nv = _callback2[0],
        nk = _callback2[1];

    result[nk] = nv;
  });
  return result;
}

function clone(object) {
  return JSON.parse(JSON.stringify(object));
}

function toPairs(object) {
  var generate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (value, key) {
    return [key, value];
  };
  var result = [];

  var _iterator3 = _createForOfIteratorHelper(iterate(object)),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = (0, _slicedToArray2.default)(_step3.value, 2),
          value = _step3$value[0],
          key = _step3$value[1];

      result.push(generate(value, key));
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return result;
}

function omit(object, fields) {
  var result = _objectSpread({}, object);

  fields.forEach(function (key) {
    delete result[key];
  });
  return result;
} // 清空一个对象


function empty(object) {
  forOwn(object, function (_, key) {
    delete object[key];
  }, true);
  return object;
}
/**
 *
 * 使用路径获取对象属性
 * @export
 * @param {*} obj
 * @param {string} desc 树形路径
 * @returns {*} 属性
 * @example
 *
 * get({a: {b: {c: 0}}}, 0) 0
 */


function get(obj, desc) {
  var arr = desc.split('.');

  while (arr.length) {
    obj = obj[arr.shift()];
  }

  return obj;
}

function deleteAttributes(obj, keys) {
  keys.forEach(function (key) {
    delete obj[key];
  });
  return obj;
}

function getObjectField(obj, desc) {
  if ((0, _is.isFunction)(desc)) {
    return desc(obj);
  }

  return get(obj, desc);
}